var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.isViewMode)?_c('div',[_vm._v(" "+_vm._s(_vm.field.display_value)+" ")]):_c('contact-search',{attrs:{"contact-id":_vm.selectedContactId,"contact-name":_vm.field.display_value},on:{"update-selected-contact":_vm.updateSelectedContact}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }